// extracted by mini-css-extract-plugin
export default {"root":"IconSessions_root__ZUdtl"};